import { render, staticRenderFns } from "./SurveyReadQuestion.vue?vue&type=template&id=9c23a1a6"
import script from "./SurveyReadQuestion.ts?vue&type=script&lang=ts&external"
export * from "./SurveyReadQuestion.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports